// src/prototype/components/SectionCard.tsx
// Titled content card with an icon + uppercase eyebrow heading, the standard
// section container on the use-case drilldown. Extracted verbatim from
// EAUseCaseBriefPage's in-file SectionCard.
import React from 'react';

export interface SectionCardProps {
  /** Leading icon (typically a lucide icon at w-3.5 h-3.5). */
  icon: React.ReactNode;
  /** Uppercase eyebrow title. */
  title: string;
  /** Section body content. */
  children: React.ReactNode;
  /** Tinted surface (#F5F7FA) instead of white when true. */
  accent?: boolean;
}

export const SectionCard: React.FC<SectionCardProps> = ({ icon, title, children, accent = false }) => (
  <div className={`rounded-xl border p-6 ${accent ? 'bg-[#F5F7FA] border-[#e5e7eb]' : 'bg-white border-[#e5e7eb]'}`}>
    <h3 className="text-xs font-semibold text-[#18365E] uppercase tracking-wide mb-3 flex items-center gap-2">{icon}{title}</h3>
    {children}
  </div>
);

export default SectionCard;
